export default __webpack_public_path__ + "img/cac_logo.8c96e6.svg";